import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 9 13.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M1.5 5.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m6 10.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0-5.25a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M7.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
    }, null, -1)
  ])))
}
export default { render: render }